'use client';

import { type Image } from '@metmuseum/types';
import styles from './hero-banner.module.scss';
import SanityImage from '@sanity-image';
import SanitySource from 'components/helper/sanity-source';
import ToolTip from 'components/tooltip';
import InfoISVG from 'assets/icons/i-icon.svg';

const HeroBanner = ({ squareImage, wideLandscapeImage, credit }: Props) => {
	if (!squareImage) {
		return null;
	}

	return (
		<div className={styles.heroBanner}>
			<picture className={styles.picture}>
				{wideLandscapeImage && (
					<SanitySource
						media="(min-aspect-ratio: 5 / 6)"
						image={wideLandscapeImage}
					/>
				)}
				{squareImage && (
					<SanitySource media="(max-aspect-ratio: 5 / 6)" image={squareImage} />
				)}
				<SanityImage
					style={{ width: '100%' }}
					sizes={'100vw'}
					priority={true}
					image={squareImage}
				/>
			</picture>
			{credit && (
				<div className={styles.toolTip}>
					<ToolTip description={credit} id="imageCredit">
						<InfoISVG />
					</ToolTip>
				</div>
			)}
		</div>
	);
};

interface Props {
	squareImage?: Image;
	wideLandscapeImage?: Image;
	credit?: string;
}

export default HeroBanner;
